/*
  First-day quick setup. Merged FIRST into TRANSLATION_MAPS in ./index.js, so
  existing translations of common words still win. Keys are the English source.
*/

const ru = {
  "Set up step by step": "Настроить по шагам",
  "Quick setup": "Быстрая настройка",
  "Answer three questions: the tracker creates the source, the offer, the campaign and its stream for you.": "Ответьте на три вопроса — трекер сам создаст источник, оффер, кампанию и её поток.",
  "1. How do you get conversions?": "1. Как вы получаете конверсии?",
  "The visitor goes to the partner site by a link (affiliate network)": "Посетитель переходит на сайт партнёра по ссылке (партнёрская сеть)",
  "The visitor fills a form, and the lead goes to the partner": "Посетитель оставляет заявку в форме, и она уходит партнёру",
  "Your own site or shop": "Свой сайт или магазин",
  "2. Where will the traffic come from?": "2. Откуда будет трафик?",
  "Other source (no template)": "Другой источник (без шаблона)",
  "3. Where should visitors go?": "3. Куда отправлять посетителей?",
  "The postback address and the click ID parameter are filled in from the network template.": "Адрес для постбэка и параметр click ID подставятся из шаблона сети.",
  "Partner integration": "Интеграция с партнёром",
  "No integrations yet — add one in Integrations, then come back.": "Интеграций пока нет — добавьте её в разделе «Интеграции» и вернитесь.",
  "Offer link from the network (or your page)": "Ссылка на оффер из сети (или ваша страница)",
  "Offer name": "Название оффера",
  "4. Campaign name": "4. Название кампании",
  "Done: the campaign and its stream are created. Put this link in your ad:": "Готово: кампания и её поток созданы. Поставьте эту ссылку в рекламу:",
  "Your own site: the click ID comes to the page as click_id; send it back to the tracker with the conversion.": "Свой сайт: click ID приходит на страницу параметром click_id — передайте его обратно в трекер вместе с конверсией.",
  "Could not finish the setup: {error}": "Не удалось завершить настройку: {error}",
  "Traffic source": "Источник трафика",
  "Offer": "Оффер",
  "Affiliate network": "Партнёрская сеть",
  "Search": "Поиск",
  "Back": "Назад",
  "Next": "Далее",
  "Create": "Создать",
  "Copy": "Копировать",
  "Copied": "Скопировано",
};

const es = {
  "Set up step by step": "Configurar paso a paso",
  "Quick setup": "Configuración rápida",
  "Answer three questions: the tracker creates the source, the offer, the campaign and its stream for you.": "Responde tres preguntas: el tracker crea por ti la fuente, la oferta, la campaña y su flujo.",
  "1. How do you get conversions?": "1. ¿Cómo obtienes las conversiones?",
  "The visitor goes to the partner site by a link (affiliate network)": "El visitante va al sitio del partner por un enlace (red de afiliados)",
  "The visitor fills a form, and the lead goes to the partner": "El visitante rellena un formulario y el lead va al partner",
  "Your own site or shop": "Tu propio sitio o tienda",
  "2. Where will the traffic come from?": "2. ¿De dónde vendrá el tráfico?",
  "Other source (no template)": "Otra fuente (sin plantilla)",
  "3. Where should visitors go?": "3. ¿A dónde enviar a los visitantes?",
  "The postback address and the click ID parameter are filled in from the network template.": "La dirección de postback y el parámetro del click ID se toman de la plantilla de la red.",
  "Partner integration": "Integración con el partner",
  "No integrations yet — add one in Integrations, then come back.": "Aún no hay integraciones: añade una en Integraciones y vuelve.",
  "Offer link from the network (or your page)": "Enlace de la oferta de la red (o tu página)",
  "Offer name": "Nombre de la oferta",
  "4. Campaign name": "4. Nombre de la campaña",
  "Done: the campaign and its stream are created. Put this link in your ad:": "Listo: se crearon la campaña y su flujo. Pon este enlace en tu anuncio:",
  "Your own site: the click ID comes to the page as click_id; send it back to the tracker with the conversion.": "Tu propio sitio: el click ID llega a la página como click_id; devuélvelo al tracker con la conversión.",
  "Could not finish the setup: {error}": "No se pudo terminar la configuración: {error}",
  "Traffic source": "Fuente de tráfico",
  "Offer": "Oferta",
  "Affiliate network": "Red de afiliados",
  "Search": "Buscar",
  "Back": "Atrás",
  "Next": "Siguiente",
  "Create": "Crear",
  "Copy": "Copiar",
  "Copied": "Copiado",
};

const pt = {
  "Set up step by step": "Configurar passo a passo",
  "Quick setup": "Configuração rápida",
  "Answer three questions: the tracker creates the source, the offer, the campaign and its stream for you.": "Responda três perguntas: o tracker cria para você a fonte, a oferta, a campanha e o fluxo dela.",
  "1. How do you get conversions?": "1. Como você recebe conversões?",
  "The visitor goes to the partner site by a link (affiliate network)": "O visitante vai ao site do parceiro por um link (rede de afiliados)",
  "The visitor fills a form, and the lead goes to the partner": "O visitante preenche um formulário, e o lead vai para o parceiro",
  "Your own site or shop": "Seu próprio site ou loja",
  "2. Where will the traffic come from?": "2. De onde virá o tráfego?",
  "Other source (no template)": "Outra fonte (sem modelo)",
  "3. Where should visitors go?": "3. Para onde enviar os visitantes?",
  "The postback address and the click ID parameter are filled in from the network template.": "O endereço de postback e o parâmetro do click ID vêm do modelo da rede.",
  "Partner integration": "Integração com o parceiro",
  "No integrations yet — add one in Integrations, then come back.": "Ainda não há integrações — adicione uma em Integrações e volte.",
  "Offer link from the network (or your page)": "Link da oferta da rede (ou sua página)",
  "Offer name": "Nome da oferta",
  "4. Campaign name": "4. Nome da campanha",
  "Done: the campaign and its stream are created. Put this link in your ad:": "Pronto: a campanha e o fluxo dela foram criados. Coloque este link no seu anúncio:",
  "Your own site: the click ID comes to the page as click_id; send it back to the tracker with the conversion.": "Seu próprio site: o click ID chega à página como click_id; envie-o de volta ao tracker com a conversão.",
  "Could not finish the setup: {error}": "Não foi possível concluir a configuração: {error}",
  "Traffic source": "Fonte de tráfego",
  "Offer": "Oferta",
  "Affiliate network": "Rede de afiliados",
  "Search": "Pesquisar",
  "Back": "Voltar",
  "Next": "Avançar",
  "Create": "Criar",
  "Copy": "Copiar",
  "Copied": "Copiado",
};

const de = {
  "Set up step by step": "Schritt für Schritt einrichten",
  "Quick setup": "Schnelleinrichtung",
  "Answer three questions: the tracker creates the source, the offer, the campaign and its stream for you.": "Beantworte drei Fragen: Der Tracker legt Quelle, Angebot, Kampagne und Stream für dich an.",
  "1. How do you get conversions?": "1. Wie bekommst du Conversions?",
  "The visitor goes to the partner site by a link (affiliate network)": "Der Besucher geht über einen Link auf die Partnerseite (Affiliate-Netzwerk)",
  "The visitor fills a form, and the lead goes to the partner": "Der Besucher füllt ein Formular aus, und der Lead geht an den Partner",
  "Your own site or shop": "Deine eigene Website oder dein Shop",
  "2. Where will the traffic come from?": "2. Woher kommt der Traffic?",
  "Other source (no template)": "Andere Quelle (ohne Vorlage)",
  "3. Where should visitors go?": "3. Wohin sollen die Besucher?",
  "The postback address and the click ID parameter are filled in from the network template.": "Postback-Adresse und Klick-ID-Parameter kommen aus der Vorlage des Netzwerks.",
  "Partner integration": "Partner-Integration",
  "No integrations yet — add one in Integrations, then come back.": "Noch keine Integrationen — lege eine unter Integrationen an und komm zurück.",
  "Offer link from the network (or your page)": "Angebotslink vom Netzwerk (oder deine Seite)",
  "Offer name": "Name des Angebots",
  "4. Campaign name": "4. Name der Kampagne",
  "Done: the campaign and its stream are created. Put this link in your ad:": "Fertig: Kampagne und Stream sind angelegt. Setze diesen Link in deine Anzeige:",
  "Your own site: the click ID comes to the page as click_id; send it back to the tracker with the conversion.": "Eigene Website: Die Klick-ID kommt als click_id auf die Seite; schicke sie mit der Conversion an den Tracker zurück.",
  "Could not finish the setup: {error}": "Die Einrichtung konnte nicht abgeschlossen werden: {error}",
  "Traffic source": "Traffic-Quelle",
  "Offer": "Angebot",
  "Affiliate network": "Affiliate-Netzwerk",
  "Search": "Suchen",
  "Back": "Zurück",
  "Next": "Weiter",
  "Create": "Erstellen",
  "Copy": "Kopieren",
  "Copied": "Kopiert",
};

const fr = {
  "Set up step by step": "Configurer étape par étape",
  "Quick setup": "Configuration rapide",
  "Answer three questions: the tracker creates the source, the offer, the campaign and its stream for you.": "Répondez à trois questions : le tracker crée pour vous la source, l’offre, la campagne et son flux.",
  "1. How do you get conversions?": "1. Comment obtenez-vous des conversions ?",
  "The visitor goes to the partner site by a link (affiliate network)": "Le visiteur va sur le site du partenaire par un lien (réseau d’affiliation)",
  "The visitor fills a form, and the lead goes to the partner": "Le visiteur remplit un formulaire, et le lead part chez le partenaire",
  "Your own site or shop": "Votre propre site ou boutique",
  "2. Where will the traffic come from?": "2. D’où viendra le trafic ?",
  "Other source (no template)": "Autre source (sans modèle)",
  "3. Where should visitors go?": "3. Où envoyer les visiteurs ?",
  "The postback address and the click ID parameter are filled in from the network template.": "L’adresse de postback et le paramètre du click ID viennent du modèle du réseau.",
  "Partner integration": "Intégration du partenaire",
  "No integrations yet — add one in Integrations, then come back.": "Pas encore d’intégration — ajoutez-en une dans Intégrations, puis revenez.",
  "Offer link from the network (or your page)": "Lien de l’offre du réseau (ou votre page)",
  "Offer name": "Nom de l’offre",
  "4. Campaign name": "4. Nom de la campagne",
  "Done: the campaign and its stream are created. Put this link in your ad:": "C’est fait : la campagne et son flux sont créés. Mettez ce lien dans votre annonce :",
  "Your own site: the click ID comes to the page as click_id; send it back to the tracker with the conversion.": "Votre propre site : le click ID arrive sur la page en click_id ; renvoyez-le au tracker avec la conversion.",
  "Could not finish the setup: {error}": "Impossible de terminer la configuration : {error}",
  "Traffic source": "Source de trafic",
  "Offer": "Offre",
  "Affiliate network": "Réseau d’affiliation",
  "Search": "Rechercher",
  "Back": "Retour",
  "Next": "Suivant",
  "Create": "Créer",
  "Copy": "Copier",
  "Copied": "Copié",
};

const it = {
  "Set up step by step": "Configura passo passo",
  "Quick setup": "Configurazione rapida",
  "Answer three questions: the tracker creates the source, the offer, the campaign and its stream for you.": "Rispondi a tre domande: il tracker crea per te la sorgente, l’offerta, la campagna e il suo flusso.",
  "1. How do you get conversions?": "1. Come ottieni le conversioni?",
  "The visitor goes to the partner site by a link (affiliate network)": "Il visitatore va sul sito del partner tramite un link (rete di affiliazione)",
  "The visitor fills a form, and the lead goes to the partner": "Il visitatore compila un modulo e il lead va al partner",
  "Your own site or shop": "Il tuo sito o negozio",
  "2. Where will the traffic come from?": "2. Da dove arriverà il traffico?",
  "Other source (no template)": "Altra sorgente (senza modello)",
  "3. Where should visitors go?": "3. Dove mandare i visitatori?",
  "The postback address and the click ID parameter are filled in from the network template.": "L’indirizzo di postback e il parametro del click ID arrivano dal modello della rete.",
  "Partner integration": "Integrazione del partner",
  "No integrations yet — add one in Integrations, then come back.": "Ancora nessuna integrazione: aggiungine una in Integrazioni e torna qui.",
  "Offer link from the network (or your page)": "Link dell’offerta dalla rete (o la tua pagina)",
  "Offer name": "Nome dell’offerta",
  "4. Campaign name": "4. Nome della campagna",
  "Done: the campaign and its stream are created. Put this link in your ad:": "Fatto: campagna e flusso sono stati creati. Metti questo link nel tuo annuncio:",
  "Your own site: the click ID comes to the page as click_id; send it back to the tracker with the conversion.": "Il tuo sito: il click ID arriva alla pagina come click_id; rimandalo al tracker con la conversione.",
  "Could not finish the setup: {error}": "Impossibile completare la configurazione: {error}",
  "Traffic source": "Sorgente di traffico",
  "Offer": "Offerta",
  "Affiliate network": "Rete di affiliazione",
  "Search": "Cerca",
  "Back": "Indietro",
  "Next": "Avanti",
  "Create": "Crea",
  "Copy": "Copia",
  "Copied": "Copiato",
};

const pl = {
  "Set up step by step": "Skonfiguruj krok po kroku",
  "Quick setup": "Szybka konfiguracja",
  "Answer three questions: the tracker creates the source, the offer, the campaign and its stream for you.": "Odpowiedz na trzy pytania: tracker sam utworzy źródło, ofertę, kampanię i jej strumień.",
  "1. How do you get conversions?": "1. Jak otrzymujesz konwersje?",
  "The visitor goes to the partner site by a link (affiliate network)": "Odwiedzający przechodzi na stronę partnera przez link (sieć afiliacyjna)",
  "The visitor fills a form, and the lead goes to the partner": "Odwiedzający wypełnia formularz, a lead trafia do partnera",
  "Your own site or shop": "Twoja własna strona lub sklep",
  "2. Where will the traffic come from?": "2. Skąd będzie ruch?",
  "Other source (no template)": "Inne źródło (bez szablonu)",
  "3. Where should visitors go?": "3. Dokąd kierować odwiedzających?",
  "The postback address and the click ID parameter are filled in from the network template.": "Adres postbacku i parametr click ID zostaną wzięte z szablonu sieci.",
  "Partner integration": "Integracja z partnerem",
  "No integrations yet — add one in Integrations, then come back.": "Nie ma jeszcze integracji — dodaj ją w Integracjach i wróć.",
  "Offer link from the network (or your page)": "Link do oferty z sieci (lub Twoja strona)",
  "Offer name": "Nazwa oferty",
  "4. Campaign name": "4. Nazwa kampanii",
  "Done: the campaign and its stream are created. Put this link in your ad:": "Gotowe: kampania i jej strumień zostały utworzone. Wstaw ten link do reklamy:",
  "Your own site: the click ID comes to the page as click_id; send it back to the tracker with the conversion.": "Twoja strona: click ID trafia na stronę jako click_id; odeślij go do trackera razem z konwersją.",
  "Could not finish the setup: {error}": "Nie udało się dokończyć konfiguracji: {error}",
  "Traffic source": "Źródło ruchu",
  "Offer": "Oferta",
  "Affiliate network": "Sieć afiliacyjna",
  "Search": "Szukaj",
  "Back": "Wstecz",
  "Next": "Dalej",
  "Create": "Utwórz",
  "Copy": "Kopiuj",
  "Copied": "Skopiowano",
};

const tr = {
  "Set up step by step": "Adım adım kur",
  "Quick setup": "Hızlı kurulum",
  "Answer three questions: the tracker creates the source, the offer, the campaign and its stream for you.": "Üç soruyu yanıtlayın: tracker kaynağı, teklifi, kampanyayı ve akışını sizin için oluşturur.",
  "1. How do you get conversions?": "1. Dönüşümleri nasıl alıyorsunuz?",
  "The visitor goes to the partner site by a link (affiliate network)": "Ziyaretçi bir bağlantıyla iş ortağının sitesine gider (satış ortaklığı ağı)",
  "The visitor fills a form, and the lead goes to the partner": "Ziyaretçi bir form doldurur ve lead iş ortağına gider",
  "Your own site or shop": "Kendi siteniz veya mağazanız",
  "2. Where will the traffic come from?": "2. Trafik nereden gelecek?",
  "Other source (no template)": "Başka kaynak (şablonsuz)",
  "3. Where should visitors go?": "3. Ziyaretçiler nereye gitsin?",
  "The postback address and the click ID parameter are filled in from the network template.": "Postback adresi ve click ID parametresi ağın şablonundan alınır.",
  "Partner integration": "İş ortağı entegrasyonu",
  "No integrations yet — add one in Integrations, then come back.": "Henüz entegrasyon yok — Entegrasyonlar bölümünden ekleyip geri dönün.",
  "Offer link from the network (or your page)": "Ağdan teklif bağlantısı (veya kendi sayfanız)",
  "Offer name": "Teklif adı",
  "4. Campaign name": "4. Kampanya adı",
  "Done: the campaign and its stream are created. Put this link in your ad:": "Tamam: kampanya ve akışı oluşturuldu. Bu bağlantıyı reklamınıza koyun:",
  "Your own site: the click ID comes to the page as click_id; send it back to the tracker with the conversion.": "Kendi siteniz: click ID sayfaya click_id olarak gelir; dönüşümle birlikte tracker’a geri gönderin.",
  "Could not finish the setup: {error}": "Kurulum tamamlanamadı: {error}",
  "Traffic source": "Trafik kaynağı",
  "Offer": "Teklif",
  "Affiliate network": "Satış ortaklığı ağı",
  "Search": "Ara",
  "Back": "Geri",
  "Next": "İleri",
  "Create": "Oluştur",
  "Copy": "Kopyala",
  "Copied": "Kopyalandı",
};

const uk = {
  "Set up step by step": "Налаштувати покроково",
  "Quick setup": "Швидке налаштування",
  "Answer three questions: the tracker creates the source, the offer, the campaign and its stream for you.": "Дайте відповідь на три запитання — трекер сам створить джерело, офер, кампанію та її потік.",
  "1. How do you get conversions?": "1. Як ви отримуєте конверсії?",
  "The visitor goes to the partner site by a link (affiliate network)": "Відвідувач переходить на сайт партнера за посиланням (партнерська мережа)",
  "The visitor fills a form, and the lead goes to the partner": "Відвідувач заповнює форму, і заявка йде партнеру",
  "Your own site or shop": "Власний сайт або магазин",
  "2. Where will the traffic come from?": "2. Звідки буде трафік?",
  "Other source (no template)": "Інше джерело (без шаблону)",
  "3. Where should visitors go?": "3. Куди відправляти відвідувачів?",
  "The postback address and the click ID parameter are filled in from the network template.": "Адреса для постбеку та параметр click ID підставляться із шаблону мережі.",
  "Partner integration": "Інтеграція з партнером",
  "No integrations yet — add one in Integrations, then come back.": "Інтеграцій поки немає — додайте її в розділі «Інтеграції» й поверніться.",
  "Offer link from the network (or your page)": "Посилання на офер із мережі (або ваша сторінка)",
  "Offer name": "Назва оферу",
  "4. Campaign name": "4. Назва кампанії",
  "Done: the campaign and its stream are created. Put this link in your ad:": "Готово: кампанію та її потік створено. Поставте це посилання в рекламу:",
  "Your own site: the click ID comes to the page as click_id; send it back to the tracker with the conversion.": "Власний сайт: click ID приходить на сторінку параметром click_id — передайте його назад у трекер разом із конверсією.",
  "Could not finish the setup: {error}": "Не вдалося завершити налаштування: {error}",
  "Traffic source": "Джерело трафіку",
  "Offer": "Офер",
  "Affiliate network": "Партнерська мережа",
  "Search": "Пошук",
  "Back": "Назад",
  "Next": "Далі",
  "Create": "Створити",
  "Copy": "Копіювати",
  "Copied": "Скопійовано",
};

const QUICK_SETUP = { ru, es, pt, de, fr, it, pl, tr, uk };
export default QUICK_SETUP;
